import React from 'react'
import Layout from '../components/layout'
import Contact from '../components/contact'
import { Container } from 'react-bootstrap'
import ColoredBanner from '../components/ColoredBanner'
import ImageWithText from '../components/ImageWithText'
import HeadingSection from '../components/HeadingSection'
import { graphql, Link } from 'gatsby'
import { kebabCase } from 'lodash'

const JobPage = ({ data, location }) => {

  return (
    <Layout location={location} linksTo="careers" title="Jobs" lang="de">
      <Container>
        <ColoredBanner backgroundColor="pink" title="Jobs.">
          <p>
            Wir suchen Charakterköpfe mit Eigeninitiative und Gestaltungswillen – Menschen, die Spaß daran haben,
            gemeinsam gewinnbringende Lösungen für unsere Kunden zu finden. Fühlst du dich angesprochen?
          </p>
          <span className="font-weight-bold">Komm ins Team!</span>
        </ColoredBanner>

        <ImageWithText imageSrc={'jobs_image_1.jpg'} imageAlt="Ein Sofa im Büro der ganztags.">
          <h2 className="mb-4">Arbeiten bei ganztags.</h2>
          <p>
            ganztags. ist eine inhabergeführte Agentur, die in allen strategischen Fragen selbst entscheidet. Wir binden
            das komplette Team mit ein, da das fachliche und menschliche Miteinander eine wichtige Grundlage für
            wirklich gute Arbeit ist. Daher haben wir auch nicht nur kurzfristig, sondern auch langfristig das Beste für
            unsere Mitarbeiter im Blick.
          </p>
          <p>
            Das schließt zum Beispiel die interne und externe Weiterbildung aller Teammitglieder ein, denn zufriedene,
            gut geschulte Angestellte sind das Zukunftskapital jedes Unternehmens. In unserem gesunden Betriebsklima ist
            jederzeit ein offener Austausch möglich, und so soll es bleiben.
          </p>
        </ImageWithText>

        <ImageWithText
          imageSrc={'jobs_image_2.jpg'}
          imageAlt="Voller Kühlschrank mit kostenlosen Getränken im Büro der ganztags."
          imageRight
        >
          <h2 className="pb-4">Deine Bewerbung</h2>
          <p>
            Bei uns gibt es keine kafkaesken Labyrinthe, die Du durchlaufen musst. Deine Bewerbung schauen wir uns
            gründlich aber zügig an und reagieren sofort. Gefällt uns, was wir lesen, laden wir dich sofort zu einem
            persönlichen Gespräch ein und lernen uns gegenseitig kennen. Schließlich wirst auch du viele Fragen haben.
          </p>
        </ImageWithText>
        {data?.jobs?.length > 0 ? (
          <HeadingSection title="Offene Stellen." id="jobs">
            {data.jobs.nodes.filter(el => el.active).map(job => (
              <h3 key={job.id}>
                <Link
                  to={`/jobs/${kebabCase(job.frontmatter.slug)}`}
                  className="job-link"
                  state={{ fromOverview: true }}
                >
                  {job.frontmatter.title}
                </Link>
              </h3>
            ))}
          </HeadingSection>
        ) : null}
        <HeadingSection title="5 gute Gründe." id="jobs" titleAlignment="right">
          <p>
            <strong>Stabilität</strong> - eine unbefristete Festanstellung sowie eine leistungsgerechte Vergütung
            schenken dir private Sicherheit.
          </p>
          <p>
            <strong>Weiterentwicklung</strong> - Mit der Teilnahme an Fachveranstaltungen und Seminaren sowie der
            Übernahme anspruchsvoller Aufgaben wird deine Lernkurve stetig steigen.
          </p>
          <p>
            <strong>Spaß</strong> - Ein vertrauensvolles Miteinander in einem sehr familiären Team sowie zahlreiche
            Teamveranstaltungen schaffen Zusammenhalt und sorgen für viel Spaß im Büro.
          </p>
          <p>
            <strong>Moderner Arbeitsplatz</strong> - Neben einem sehr zentral gelegenen und modernen Büro bieten wir dir
            auch die Wahl deiner Hardware sowie die individuelle Gestaltung deines Arbeitsplatzes.
          </p>
          <p>
            <strong>Vertrauen</strong> - Das Einbringen deiner Ideen, die Übernahme eigener Projekte, kurze
            Entscheidungswege aber auch die Wertschätzung deiner Arbeit ermöglichen es dir, das Beste aus dir
            rauszuholen.
          </p>
        </HeadingSection>
      </Container>
      <Contact />
    </Layout>
  )
}

export default JobPage

export const query = graphql`
  {
    jobs: allMdx(filter: { internal: { contentFilePath: { regex: "/files/jobs/i" } } }) {
      nodes {
        body
        id
        frontmatter {
          slug
          title
          active
        }
      }
    }
  }
`
